var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-0",attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view',{on:{"isLoading":_vm.showLoading}})],1),(_vm.isLoading)?_c('loading-spinner'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }